import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_19 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;
  return (
    <>
      <g>
        <path
          fill={primary}
          d="M446.8,256.5c-18.3,14.3-74.4,51.6-98.5,91.4c-35.6,58.8-28.7,137.5-25.6,177.2
		c2.9,36.9,26.4,104.5,67.4,120.9c-21.7,1.4-94.7-28.4-135.8-91C209,486.3,211,410,217.3,344.3c3.7-39.6,22.7-102.2,80.5-142.5
		c36-25.1,103.1-45.3,154.9-28c25,8.3,34.4,23.8,34.4,23.8s10.7-2.9,24.1,4.1c20.9,10.9,33.2,25.8,44.8,45
		c11.8,19.6,22.3,52.4,25.5,74.5c6.9,47.4,3.4,100.3-16.2,151.2c-14,36.5-35.9,63.7-60.3,82.6c-29.1,22.7-53.4,24.4-53.4,24.4
		s30.2-26.9,42.4-73.4c15.5-58.9,15.6-120.8,14.2-143.3c-2-31.5-7.4-58.9-16.7-85.6c-8.7-24.8-14.7-49.4-14.7-49.4
		S462,244.6,446.8,256.5z"
        />
        <path
          fill={secondary}
          d="M493.8,217.1c0,0,11.4,39.4,16.1,54.5c11.4,37.1,15.1,88.3,14.6,135.6c-1,96-36,152.2-36,152.2
		s39.9-36.8,42.9-156.9c1.4-58.2-10.4-101.9-17.2-127.1C510.7,262.4,493.8,217.1,493.8,217.1z"
        />
        <path
          fill={secondary}
          d="M495.9,220.3c0,0,15.3,32.5,21.5,44.9c15,30.5,25.9,73.9,32.7,114.5c13.9,82.2-6,134.2-6,134.2
		s26.8-35.9,10.9-139c-7.7-49.9-24.1-86.1-33.5-106.9C516.6,257.2,495.9,220.3,495.9,220.3z"
        />
        <path
          fill={secondary}
          d="M490.7,203.8c0,0,18.8,28.1,26.2,38.8c18.2,26.3,34.5,64.9,46.7,101.2c24.8,73.7,0,132.4,0,132.4
		s27.2-44.9,3.8-137.4c-11.5-45.4-34.7-76.2-46.4-94.1C515.1,235.3,490.7,203.8,490.7,203.8z"
        />
        <path
          fill={secondary}
          d="M500,207.4c0,0,55.8,39.3,73,120.4c16.5,78.3-13.6,125.8-13.6,125.8s31.8-33.5,17.3-130.7
		c-6.9-46.1-34.7-76.2-46.4-94.1C524.4,219.4,500,207.4,500,207.4z"
        />
        <path
          fill={secondary}
          d="M469.2,212.1c0,0-97.7,25.7-142.4,80.7c-44.7,55-50.2,88.2-51.8,130.8c-1.5,41.2,14.9,105.1,30.6,138.5
		c15.7,33.4,40.6,61,40.6,61s-27.6-26.6-42.9-56.9c-15.5-30.6-34.5-90.2-36.1-144c-1.6-53.8,17.8-97.4,52.5-132.5
		C375.9,233,469.2,212.1,469.2,212.1z"
        />
        <path
          fill={secondary}
          d="M467.1,217.1c0,0-72.1,37.1-119,92.1c-46.8,55-52.6,88.1-54.2,130.8c-1.6,41.2,10.7,105.1,27.1,138.5
		c16.4,33.4,39.7,59.1,39.7,59.1s-26.1-24.7-42.2-55c-16.3-30.6-31.2-90.2-32.9-144c-1.6-53.8,18.6-97.4,55.1-132.5
		C399.5,249.4,467.1,217.1,467.1,217.1z"
        />
        <path
          fill={secondary}
          d="M443.1,211.3c0,0-88.6,14.5-136.3,66.5c-47.6,52-55.9,84.8-61.2,127.2c-5.2,41,11.3,103.7,23.2,138
		c12,34.3,36.8,48.2,36.8,48.2s-30.2-18.5-42.1-49.6c-12-31.5-28.7-84.7-25.3-138.4c3.4-53.7,28-94,62.1-128.8
		C355.6,218,443.1,211.3,443.1,211.3z"
        />
        <path
          fill={secondary}
          d="M456.2,203.1c0,0-97.9-4.1-151.9,45.9c-54,50-64.2,82.4-71.6,124.6c-7.2,40.7-3.7,105.4,8.1,140.2
		c11.8,34.8,22.8,48.5,22.8,48.5s-11-16.9-22.8-48.5c-12-32-21.8-88.7-16.1-142.3c5.7-53.6,31.7-94.9,72.7-126.3
		C363.5,194.6,456.2,203.1,456.2,203.1z"
        />
        <path
          fill={secondary}
          d="M469.2,208.6c0,0-49.6-37.3-119.1-3.6c-69.4,33.7-90.8,62-113.1,100.2c-21.5,37-8.6,130.5-9.9,166.6
		c-1.3,36.1,10.6,55.2,10.6,55.2s-10.7-22.1-10.6-55.2c0.1-33.6-18.1-119.5,6.6-169.1c24.7-49.6,60.8-83.9,111.1-103.2
		C426.1,168.5,469.2,208.6,469.2,208.6z"
        />
        <path
          fill={secondary}
          d="M489.4,200.7c6-1.4,10.9,0,18.2,1.2c-1.2,0.7-4.2,0.5-6.1,1.1c4.2,1.6,9.8,4.6,12.8,7.5
		c-2.2-0.2-4.2-0.9-6.4-1.4c0.4,1.3,1.4,2.9,2.5,4.1c-0.7-0.1-1.8,0.2-2.5,0.2c0.2,0.8-0.3,1.9-0.1,2.7c-1.7-0.2-3.2,0-4.7-0.9
		c1.3,7.3,6.5,14.1,7.9,21.6c-3.3-3.1-4.9-7.4-8.3-10.5c-3.5-3.2-7.9-4.4-12.4-6c1.5,3,3.9,6,4.2,9.2c-1.3-1-2.3-2.2-3.1-3.5
		c0.1,0.6-0.4,4.7-0.4,5.3c-3.2,0.3-5-5.5-7.8-6.4c-0.4,2.1,0.2,5.9,0.6,7.9c-2.6-4.3-2.4-7.6-6.4-9.6c-4.4-2.3-6.2,0.4-11.2-0.1
		c1.2-0.9,0.8-1.4,1.4-2.3c-5-0.8-12.5,2.7-16.9,4.5c1.2-3.7,5.2-5,8.4-7.1c-8.7-2.7-17.8-0.8-26.9-1.4c5.9-1.1,13.8-2.3,19.4-4.4
		c-2.4,0.3-5.5-1.1-8.8-1.1c0.8-0.3,4.7-1.9,5.3-2.2c-2.9-0.2-6-0.8-8.7-1.8c4.9-2.6,11.5-3.6,17.2-3.9c-9-3.9-17.7-8.5-27.1-11.4
		c5.8,1.3,12.6,1.4,18.2,3.2c4.7,1.4,9.3,3.5,13.9,5c-2.2-5-8.2-9-11.8-13.6c4.5,1.3,9.5,4.2,13.5,6.4c-0.1-0.7,0-4.6-0.1-5.3
		c2.9,2,7.7,5.8,10.5,7.2c-0.1-2.3-1.8-5.7-2.7-9.1c4.2,3.4,12.2,10.5,15,14.9L489.4,200.7z"
        />
      </g>
    </>
  );
};

export default Hair_19;
